import { NgModule } from '@angular/core';
import { savedCartTranslationChunksConfig, savedCartTranslationsDe, savedCartTranslationsEn } from '@spartacus/cart/saved-cart/assets';
import { SavedCartRootModule } from '@spartacus/cart/saved-cart/root';
import { CmsConfig, I18nConfig, provideConfig } from '@spartacus/core';
import { nl as translationsNl } from '../../../../assets/i18n-assets/nl';

@NgModule({
  declarations: [],
  imports: [
    SavedCartRootModule
  ],
  providers: [provideConfig({
    featureModules: {
      cartSavedCart: {
        module: () =>
          import('@spartacus/cart/saved-cart').then((m) => m.SavedCartModule),
      },
    }
  } as CmsConfig),
  provideConfig({
    i18n: {
      resources: {
          en: savedCartTranslationsEn,
          de: savedCartTranslationsDe,
          nl: translationsNl,
        },
      chunks: savedCartTranslationChunksConfig,
    },
  } as I18nConfig)
  ]
})
export class CartSavedCartFeatureModule { }
